import React from 'react';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { ExecutorPickerModal } from '../parts/ExecutorPickerModal';
import { IReplacePerformerProps } from './IReplacePerformerProps';

export const ReplacePerformerModal: React.FC<IReplacePerformerProps> = (props: IReplacePerformerProps) => {
    const serv = new ActivityExecutionService();

    return (
        <ExecutorPickerModal
            {...props}
            loadModel={() => serv.getReplacePerformerModel(props.actionKey, props.activityId)}
            submit={(form) => serv.saveReplacePerformer(props.actionKey, props.activityId, form?.executor)}
        />
    );
};
